var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2761 38.0194C30.7452 38.0194 38.4213 30.3432 38.4213 20.8741C38.4213 11.4051 30.7452 3.72888 21.2761 3.72888C11.807 3.72888 4.13086 11.4051 4.13086 20.8741C4.13086 30.3432 11.807 38.0194 21.2761 38.0194ZM11.9519 11.4374C11.5014 11.8557 11.2761 12.3867 11.2761 13.0303C11.2761 13.6739 11.4949 14.2081 11.9326 14.6329C12.3702 15.0576 12.943 15.27 13.651 15.27H13.6703C14.404 15.27 14.9961 15.0576 15.4466 14.6329C15.8842 14.2209 16.103 13.7061 16.103 13.0882C16.103 12.406 15.8778 11.8525 15.4273 11.4278C14.9896 11.0159 14.4168 10.8099 13.7089 10.8099C12.9881 10.8099 12.4024 11.0191 11.9519 11.4374ZM11.5271 17.027V29.9246H15.8134V17.027H11.5271ZM22.4746 29.9246H18.1883C18.214 26.0373 18.2269 23.0188 18.2269 20.8692C18.2269 18.7196 18.214 17.4389 18.1883 17.027H22.4746V18.8612L22.4553 18.8999H22.4746V18.8612C23.4013 17.4325 24.695 16.7181 26.3554 16.7181C27.8357 16.7181 29.0263 17.2104 29.9273 18.1951C30.8284 19.1798 31.2789 20.6247 31.2789 22.5297V29.9246H26.9926V23.0317C26.9926 21.0881 26.2718 20.1162 24.8301 20.1162C24.2766 20.1162 23.8165 20.2675 23.4496 20.57C23.0828 20.8724 22.8092 21.2425 22.629 21.6802C22.5261 21.9247 22.4746 22.2723 22.4746 22.7228V29.9246Z",
    fill: "#AAC7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.6df820f58976fbcf6f31dee79f9b21a2.svg";
export { ForwardRef as ReactComponent };